import { render, staticRenderFns } from "./StatisticsByBids.vue?vue&type=template&id=6bdd6d42&scoped=true&"
import script from "./StatisticsByBids.vue?vue&type=script&lang=js&"
export * from "./StatisticsByBids.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsByBids.vue?vue&type=style&index=0&id=6bdd6d42&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd6d42",
  null
  
)

export default component.exports